<template>
  <div class="add-user">
      INTRO
  </div>
</template>

<script>
export default {
  name: "Provider_Site_Intro",
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {
        return {};
      }
    },
    provider: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
